import React, { useEffect, useState, useRef, memo, useContext } from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { fmt } from "../../../util/helper";
import { getStock } from './stock'
import { Button } from "react-bootstrap";
import { isEmptyObject } from "../../../util/helper";
import { makeStyles } from "@material-ui/styles";
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveCircleIcon from '../../../assets/icons/remove.svg';
import { ShowChart } from "@mui/icons-material";
import PlusMinQty from "../../../components/utilities/PlusMinQty";

// style constant
const useStyles = makeStyles((theme) => ({

  headingCol: {
    //fontWeight: "bold",
    padding: "4px",
    fontFamily: "poppins",

  },
  // sticky: {
  //   position: "sticky",
  //   left: 0,
  //   background: "white",
  //   boxShadow: "5px 2px 5px grey",
  //   borderRight: "2px solid black"
  // }
}));
const DataTableRow = ({ DropDonwcolumns, rowHover, pageType, middleStrike, user, source, rowData, tokens, prev, clickedTab, buySellClick, handleDeleteRow, chartClick, handleQtyChange, optionType }) => {
  const [data, setData] = useState({});
  const dataRef = useRef();
  const subscriptionRef = useRef();
  const [hoverValue, setHoverValue] = useState('');

  const classes = useStyles();
  dataRef.current = data;
  useEffect(() => {
    setData({});

    if (rowData) {
      setData(rowData);
    }

  }, [rowData]);

  useEffect(() => {
    if (source && tokens) {
      var subscription1 = source
        .subscribe("" + tokens.PE, (message) => handleResponse(message, "pe"))
        .on("unsubscribe", () => { })
        .on("subscribe", () => { })
        .on("error", handleSubscribeError);
      var subscription2 = source
        .subscribe("" + tokens.CE, (message) => handleResponse(message, "ce"))
        .on("unsubscribe", () => { })
        .on("subscribe", () => { })
        .on("error", handleSubscribeError);

      subscriptionRef.current = { ce: subscription1, pe: subscription2 };

      return () => {
        subscription1.unsubscribe();
        subscription2.unsubscribe();
      };
    }

  }, [source, tokens]);

  const calculateClose = (newData, open = "") => {
    const straddleLP = newData.straddleLP - newData["straddleChg" + open];
    const currentPrice = newData["straddleChg" + open];
    const closePrice = (currentPrice / straddleLP) * 100;
    return closePrice.toFixed(2);
  };

  const handleResponse = (message, type) => {

    if (dataRef.current && !isEmptyObject(dataRef.current)) {
      const myJSON = JSON.stringify(message);
      const text = safeTagsReplace(myJSON);
      const data = JSON.parse(text)?.data;

      const newData = { ...dataRef.current, ...getStock(data, type, prev) };

      newData["straddleLP"] =
        !isNaN(newData.ceLP) && !isNaN(newData.peLP)
          ? newData.ceLP + newData.peLP
          : "-";
      newData["straddleChg"] =
        !isNaN(newData.ceChg) && !isNaN(newData.peChg)
          ? newData.ceChg + newData.peChg
          : "-";
      newData["straddlePChg"] =
        !isNaN(newData.cePChg) && !isNaN(newData.pePChg)
          ? newData.cePChg + newData.pePChg
          : "-";
      newData["straddleChg_open"] =
        !isNaN(newData.ceChg_open) && !isNaN(newData.peChg_open)
          ? newData.ceChg_open + newData.peChg_open
          : "-";
      newData["straddlePChg_open"] =
        !isNaN(newData.cePChg_open) && !isNaN(newData.pePChg_open)
          ? newData.cePChg_open + newData.pePChg_open
          : "-";

      setData(newData);
    }
  };

  const tagsToReplace = { "&": "&amp;", "<": "&lt;", ">": "&gt;" };

  const handleRowHover = (tokens) => {
    setHoverValue(tokens)

  };
  const handleRowHoverLeave = (tokens) => {
    setHoverValue("")
  };
  function handleSubscribeError(err) {
    console.log("Error subscribing on channel symbol ", tokens, err);
  }

  function replaceTag(tag) {
    return tagsToReplace[tag] || tag;
  }

  function safeTagsReplace(str) {
    return str.replace(/[&<>]/g, replaceTag);
  }



  const getClassName = (value) => {
    let cls =
      value > 0 ? "positive-chg" : value < 0 ? "negative-chg" : "no-chg";

    return `straddle-cell ${cls}`;
  };

  return (
    <TableRow className={middleStrike === data.strike ? "straddle-table-row " : "straddle-table-row"}>
      {pageType === "custom" && (
        <TableCell align="center" className={classes.headingCol}>
          <span style={{
            color: data.side === "BUY" ? "#00d27a" : "#ef5350",
            fontWeight: 700,
            fontSize: '11px',
            padding: '2px 6px',
            borderRadius: '4px',
            background: data.side === "BUY" ? "#00d27a15" : "#ef535015"
          }}>
            {data.side}
          </span>
        </TableCell>
      )}

      {(pageType !== "custom" || optionType === "Both" || optionType === "CE only") && (
        <>
          <TableCell align="center" className={"dataCell ceCell" + ' ' + classes.headingCol}>
            {fmt((pageType === "strangle" || pageType === "custom") ? data.strikeCE : data.strike)}
          </TableCell>

          {DropDonwcolumns.filter((item) => item.accessorKey === "deltaCE" && item.enableColumn).length > 0 &&
            <TableCell id={(pageType === "strangle" || pageType === "custom") ? data.strikeCE + "-deltaCE" : data.strike + "-deltaCE"} align="center" className={"dataCell ceCell" + ' ' + classes.headingCol}>
              {pageType === "strangle" ? data?.cedelta?.toFixed(2) : data?.deltaCE?.toFixed(2)}
            </TableCell>
          }
          <TableCell id={(pageType === "strangle" || pageType === "custom") ? data.strikeCE + "-lpCE" : data.strike + "-lpCE"} align="center" className={"dataCell ceCell ltpCell lpCE call-ltp-color " + ' ' + classes.headingCol} onMouseLeave={(e) => handleRowHoverLeave(tokens.CE)} onMouseEnter={(e) => handleRowHover(tokens.CE)} >
            <div className="opt-p-btn" style={{ position: "relative" }}>
              {!isNaN(data.ceLP) ? fmt(data.ceLP.toFixed(2)) : "-"}
              {pageType !== "custom" && (
                <div style={{ gap: "0" }} className={hoverValue == tokens.CE ? 'bs-btn ltp-b-s-btn active-buy-sell' : 'bs-btn ltp-b-s-btn in-active-buy-sell'} >
                  <Button size="sm" type="button" className="oc-btn btn-chart" onClick={() => chartClick(rowData, "CE", ((pageType === "strangle" || pageType === "custom") ? data.strikeCE : data.strike), pageType, false)}><ShowChart /></Button>
                  <Button onMouseLeave={(e) => rowHover("B", "ce", rowData, false, 'st', 'l')} onMouseEnter={(e) => rowHover("B", "ce", rowData, false, 'st', 'e')} size="sm" type="button" className="oc-btn qt-buy-btn" onClick={() => buySellClick("BUY", { lpPE: data.peLP, lpCE: data.ceLP }, tokens, 'CE', ((pageType === "strangle" || pageType === "custom") ? data.strikeCE : data.strike), false, pageType)}>B</Button>
                  <Button onMouseLeave={(e) => rowHover("S", "ce", rowData, false, 'st', 'l')} onMouseEnter={(e) => rowHover("S", "ce", rowData, false, 'st', 'e')} size="sm" type="button" className="oc-btn qt-sell-btn" onClick={() => buySellClick("SELL", { lpPE: data.peLP, lpCE: data.ceLP }, tokens, 'CE', ((pageType === "strangle" || pageType === "custom") ? data.strikeCE : data.strike), false, pageType)}>S</Button>
                </div>
              )}
            </div>
          </TableCell>
        </>
      )}

      {(pageType !== "custom" || optionType === "Both" || optionType === "PE only") && (
        <>
          <TableCell align="center" className={"dataCell peCell" + ' ' + classes.headingCol}>
            {fmt(data.strikePE)}
          </TableCell>

          <TableCell id={(pageType === "strangle" || pageType === "custom") ? data.strikePE + "-lpPE" : data.strike + "-lpPE"} align="center" className={"dataCell peCell ltpCell lpPE put-ltp-color " + ' ' + classes.headingCol} onMouseLeave={(e) => handleRowHoverLeave(tokens.PE)} onMouseEnter={(e) => handleRowHover(tokens.PE)}>
            <div className="opt-p-btn" style={{ position: "relative" }}>
              {!isNaN(data.peLP) ? fmt(data.peLP.toFixed(2)) : "-"}
              {pageType !== "custom" && (
                <div style={{ gap: "0" }} className={hoverValue == tokens.PE ? 'bs-btn ltp-b-s-btn active-buy-sell' : 'bs-btn ltp-b-s-btn in-active-buy-sell'} >
                  <Button size="sm" type="button" className="btn btn-chart buy-info p-0" onClick={() => chartClick(rowData, "PE", data.strikePE, pageType, false)}><ShowChart /></Button>
                  <Button onMouseLeave={(e) => rowHover("B", "pe", rowData, false, 'st', 'l')} onMouseEnter={(e) => rowHover("B", "pe", rowData, false, 'st', 'e')} size="sm" type="button" className="oc-btn qt-buy-btn" onClick={() => buySellClick("BUY", { lpPE: data.peLP, lpCE: data.ceLP }, tokens, 'PE', data.strikePE, false, pageType)}>B</Button>
                  <Button onMouseLeave={(e) => rowHover("S", "pe", rowData, false, 'st', 'l')} onMouseEnter={(e) => rowHover("S", "pe", rowData, false, 'st', 'e')} size="sm" type="button" className="oc-btn qt-sell-btn" onClick={() => buySellClick("SELL", { lpPE: data.peLP, lpCE: data.ceLP }, tokens, 'PE', data.strikePE, false, pageType)}>S</Button>
                </div>
              )}
            </div>
          </TableCell>
          {DropDonwcolumns.filter((item) => item.accessorKey === "deltaPE" && item.enableColumn).length > 0 &&
            <TableCell id={(pageType === "strangle" || pageType === "custom") ? data.strikePE + "-deltaPE" : data.strike + "-deltaPE"} align="center" className={"dataCell peCell right-border-std" + ' ' + classes.headingCol}>
              {pageType === "strangle" ? data?.pedelta?.toFixed(2) : data?.deltaPE?.toFixed(2)}
            </TableCell>
          }
        </>
      )}


      {pageType !== "custom" && <TableCell align="center" className={"dataCell ltpCell" + ' ' + classes.headingCol} onMouseLeave={(e) => handleRowHoverLeave(tokens.CE + '-' + tokens.PE)} onMouseEnter={(e) => handleRowHover(tokens.CE + '-' + tokens.PE)}>
        <div className="opt-p-btn" style={{ position: "relative" }}>
          {!isNaN(data.straddleLP) ? fmt(data.straddleLP.toFixed(2)) : "-"}
          <div style={{ gap: "0" }} className={hoverValue == tokens.CE + '-' + tokens.PE ? 'bs-btn ltp-b-s-btn active-buy-sell' : 'bs-btn ltp-b-s-btn in-active-buy-sell'} >
            <Button size="sm" type="button" className="btn btn-chart buy-info p-0" onClick={() => chartClick(data, "PE", data.strikePE, pageType, true)}><ShowChart /></Button>
            <Button onMouseLeave={(e) => rowHover("B", "ce", rowData, true, 'st', 'l')} onMouseEnter={(e) => rowHover("B", "ce", rowData, true, 'st', 'e')} size="sm" type="button" className="oc-btn qt-buy-btn" onClick={() => buySellClick("BUY", { lpPE: data.peLP, lpCE: data.ceLP, data: data }, tokens, 'PE', data.strikePE, true, pageType)}>B</Button>
            <Button onMouseLeave={(e) => rowHover("S", "ce", rowData, true, 'st', 'l')} onMouseEnter={(e) => rowHover("S", "ce", rowData, true, 'st', 'e')} size="sm" type="button" className="oc-btn qt-sell-btn" onClick={() => buySellClick("SELL", { lpPE: data.peLP, lpCE: data.ceLP, data: data }, tokens, 'PE', data.strikePE, true, pageType)}>S</Button>
          </div>
        </div>
      </TableCell>}
      {pageType !== "custom" && DropDonwcolumns.filter((item) => item.accessorKey === "ivCE" && item.enableColumn).length > 0 &&
        <TableCell align="center" className={"dataCell ceCell right-border-std" + ' ' + classes.headingCol}>
          {pageType === "strangle" ? data.ceiv : data.ivCE}
        </TableCell>
      }
      {pageType !== "custom" && DropDonwcolumns.filter((item) => item.accessorKey === "ivPE" && item.enableColumn).length > 0 &&
        <TableCell align="center" className={"dataCell peCell right-border-std" + ' ' + classes.headingCol}>
          {pageType === "strangle" ? data.peiv : data.ivPE}
        </TableCell>
      }
      {pageType === "custom" &&
        <TableCell style={{justifyContent: 'center', display: 'flex'}} align="center" className={"dataCell" + ' ' + classes.headingCol} >
           <PlusMinQty 
              qtyClick={(val) => handleQtyChange(data.id, val)}
              filterValue={data.qty}
              step={data.lotSize}
              min={1}
              style={{width: '90px', margin: '0 2px'}}
           />
        </TableCell>
      }
    </TableRow>
  );
};

export default memo(DataTableRow);
